export default __webpack_public_path__ + "static/media/sh_13.891f88d8.png";